import type Category from '../../core/types/category';
import { COUNT_CATEGORIES_IN_DESCRIPTION } from '../constants';
import findInTreeNodes from '../../core/util/findInTreeNodes';

const takeCategoriesFromTree = (
    tree: Category[],
    count = COUNT_CATEGORIES_IN_DESCRIPTION
): Category[] => {
    if (!tree.length) {
        return [];
    }

    const sortedCategories = tree
        .slice()
        .sort(
            ({ count: countA = 0 }, { count: countB = 0 }) => countB - countA
        );
    const categories = sortedCategories.slice(0, count);
    const diff = count - categories.length;

    if (diff > 0) {
        let nextCategories: Category[] = [];
        for (const category of categories) {
            if (category.children.length) {
                nextCategories = category.children;
                break;
            }
        }

        return categories.concat(takeCategoriesFromTree(nextCategories, diff));
    }

    return categories;
};

export const getCategoriesDescription = (
    tree: Category[],
    categoryId?: string
) => {
    if (!tree.length) {
        return [];
    }

    const selectedCategory = findInTreeNodes(
        tree,
        node => node.id === categoryId
    );

    if (!selectedCategory) {
        return takeCategoriesFromTree(tree);
    }

    return [
        selectedCategory,
        ...takeCategoriesFromTree(
            selectedCategory.children,
            COUNT_CATEGORIES_IN_DESCRIPTION - 1
        ),
    ];
};
